import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { showToastErrorMessageAction, showToastSuccessMessageAction, showToastWarningMessageAction } from './toast.actions';
import { IToastFeature } from './toast.feature.state';
import { getFailures, getIsLoading } from './toast.selectors';

@Injectable()
export class ToastFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);

  constructor(private store: Store<IToastFeature>) {}

  public showToastSuccessMessage(message: string): void {
    this.store.dispatch(showToastSuccessMessageAction({ message }));
  }

  public showToastWarningMessage(message: string): void {
    this.store.dispatch(showToastWarningMessageAction({ message }));
  }

  public showToastErrorMessage(message: string): void {
    this.store.dispatch(showToastErrorMessageAction({ message }));
  }
}
